var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-modal', {
    attrs: {
      "title": "Import Data",
      "ok-title": "Submit",
      "loading": _vm.loadingImport
    },
    on: {
      "ok": _vm.handleImportRh
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("Import Data")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModal = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [[_c('div', {
    staticClass: "flex flex-column align-items-center"
  }, [_c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  }), _c('small', {
    staticClass: "text-black"
  }, [_vm._v("accept: .xlsx, .xls, .csv")])], 1), !_vm.loadingExportTemplate ? _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExportTemplateRH
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template ")]) : _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "18px",
      "height": "18px"
    }
  }), _vm._v(" Downloading ")], 1)]], 2), _c('b-modal', {
    attrs: {
      "title": "History Reset RH",
      "size": "lg",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("History Reset RH")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showHistoryModal = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showHistoryModal,
      callback: function callback($$v) {
        _vm.showHistoryModal = $$v;
      },
      expression: "showHistoryModal"
    }
  }, [[_c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "w-100 table-striped table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Fleet Name")]), _c('th', [_vm._v("Date Time")]), _c('th', [_vm._v("Reset By")])])]), _vm.historyResetData.length ? _c('tbody', _vm._l(_vm.historyResetData, function (item) {
    var _item$vehicle, _item$deletedByUser, _item$deletedByUser$d;
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('b-badge', {
      attrs: {
        "variant": "success"
      }
    }, [_vm._v(" " + _vm._s(((_item$vehicle = item.vehicle) === null || _item$vehicle === void 0 ? void 0 : _item$vehicle.name) || '-') + " ")])], 1), _c('td', [_vm._v(" " + _vm._s(_vm.formatDateTime(item.created_at)) + " ")]), _c('td', [_vm._v(" " + _vm._s(((_item$deletedByUser = item.deletedByUser) === null || _item$deletedByUser === void 0 ? void 0 : (_item$deletedByUser$d = _item$deletedByUser.detail) === null || _item$deletedByUser$d === void 0 ? void 0 : _item$deletedByUser$d.name) || '-') + " ")])]);
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center py-4",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No Data")])])])])])]], 2), _c('b-modal', {
    attrs: {
      "title": "Import Result",
      "size": "xl",
      "hide-footer": ""
    },
    model: {
      value: _vm.modalResponseImport,
      callback: function callback($$v) {
        _vm.modalResponseImport = $$v;
      },
      expression: "modalResponseImport"
    }
  }, [_c('ImportResultRh', {
    attrs: {
      "response": _vm.dataResponseImport
    }
  })], 1), _c('b-sidebar', {
    attrs: {
      "right": "",
      "width": "80%",
      "title": "Add New Running Hours",
      "header-class": "p-0 bg-white",
      "body-class": "p-3",
      "shadow": "",
      "backdrop": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "w-100 p-2 px-3 d-flex justify-content-between align-items-center",
          staticStyle: {
            "border-bottom": "1px solid",
            "font-size": "18px",
            "font-weight": "600"
          }
        }, [_c('i', {
          staticClass: "fa fa-close cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showCanvas = false;
            }
          }
        }), _c('p', {
          staticClass: "m-0"
        }, [_vm._v(" " + _vm._s(_vm.selectedData ? 'Update' : 'Create') + " Running Hours ")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showCanvas,
      callback: function callback($$v) {
        _vm.showCanvas = $$v;
      },
      expression: "showCanvas"
    }
  }, [[_c('div', {
    staticClass: "bg-white p-4 shadow-sm",
    staticStyle: {
      "border-radius": "8px"
    }
  }, [_vm.showCanvas ? _c('formRunningHours', {
    attrs: {
      "isFormDetail": "",
      "selectedData": _vm.selectedData
    },
    on: {
      "close": function close($event) {
        _vm.showCanvas = false;
      },
      "refetch": _vm.fetchDataRh
    }
  }) : _vm._e()], 1)]], 2), _c('custom-sidebar', {
    attrs: {
      "size": "980px",
      "title": "Adjustmnet Running Hours"
    },
    model: {
      value: _vm.sidebarAdjustment,
      callback: function callback($$v) {
        _vm.sidebarAdjustment = $$v;
      },
      expression: "sidebarAdjustment"
    }
  }, [_vm.sidebarAdjustment ? _c('div', {
    staticClass: "bg-white shadow-sm p-4"
  }, [_c('RhAdjustmnetList', {
    attrs: {
      "dataRh": _vm.selectedAdjustmentData
    }
  })], 1) : _vm._e()]), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("RUNNING HOURS")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$rhData$data, _Object$keys, _vm$rhData$data$, _vm$rhData$data$$powe, _vm$rhData$data2;
        return [_c('b-row', [_c('FilterRh', {
          attrs: {
            "filters": _vm.filters
          }
        }), _c('b-col', {
          staticClass: "d-flex justify-content-end",
          attrs: {
            "lg": "6"
          }
        }, [_c('b-button', {
          staticClass: "d-flex align-items-center",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary",
            "disabled": _vm.loadingExport
          },
          on: {
            "click": function click($event) {
              return _vm.handleExport();
            }
          }
        }, [!_vm.loadingExport ? [_c('i', {
          staticClass: "ri-upload-2-line pl-1"
        }), _vm._v(" Export ")] : [_c('b-spinner', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          }
        }), _vm._v(" Exporting... ")]], 2), _c('b-button', {
          staticClass: "d-flex align-items-center mx-2",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModal = true;
            }
          }
        }, [_c('i', {
          staticClass: "ri-download-2-line pl-1"
        }), _vm._v(" Import ")]), _c('b-button', {
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.showCanvas = true;
              _vm.selectedData = null;
            }
          }
        }, [_vm._v(" Add Running Hours ")])], 1), !_vm.loading ? [(_vm$rhData$data = _vm.rhData.data) !== null && _vm$rhData$data !== void 0 && _vm$rhData$data.length ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "overflow-auto",
          staticStyle: {
            "position": "relative"
          }
        }, [_c('table', {
          staticClass: "w-100 table-striped table-bordered table-hover"
        }, [_c('tr', [_c('th', {
          staticClass: "text-center column-1",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("FLEET")]), _c('th', {
          staticClass: "text-enter column-2",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("LAST MONTH")]), _c('th', {
          staticClass: "column-3",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("ENGINE NAME")]), _c('th', {
          staticClass: "text-center",
          attrs: {
            "colspan": (_Object$keys = Object.keys((_vm$rhData$data$ = _vm.rhData.data[0]) === null || _vm$rhData$data$ === void 0 ? void 0 : (_vm$rhData$data$$powe = _vm$rhData$data$.powers[0]) === null || _vm$rhData$data$$powe === void 0 ? void 0 : _vm$rhData$data$$powe.days)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length
          }
        }, [_vm._v(" " + _vm._s(_vm.moment(_vm.filters.month).format('MMMM')) + " ")]), _c('th', {
          staticClass: "text-center",
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v("TOTAL RUNNING HOURS")])]), _c('tr', [_vm._l(_vm.rhData.data[0].powers[0].days, function (value, key, index) {
          return _c('th', {
            key: key,
            staticClass: "text-center"
          }, [_vm._v(" " + _vm._s(key) + " ")]);
        }), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "180px"
          }
        }, [_vm._v(" ADJUSTMENT ")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "180px"
          }
        }, [_vm._v(" THIS MONTH ")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "180px"
          }
        }, [_vm._v(" SINCE GOH ")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "180px"
          }
        }, [_vm._v(" ALL TIME ")])], 2), _c('tbody', [_vm._l(_vm.rhData.data, function (item, i) {
          return _vm._l(item === null || item === void 0 ? void 0 : item.powers, function (subItem, j) {
            var _item$powers, _item$powers2, _subItem$power_type, _subItem$power_series, _item$powers4, _item$powers5, _item$powers6, _subItem$sinceGOH, _item$powers7;
            return _c('tr', {
              key: "".concat(i, "-").concat(j)
            }, [j === 0 ? _c('td', {
              staticClass: "bg-white column-1 border-yellow",
              attrs: {
                "align": "center",
                "rowspan": item.powers.length
              }
            }, [_c('div', {
              staticClass: "d-flex flex-column justify-center-center"
            }, [_c('div', {
              staticClass: "mb-2 bg-success py-1",
              staticStyle: {
                "cursor": "default"
              }
            }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.vehicle_name) + " ")]), _c('div', [_c('b-button', {
              staticClass: "w-100",
              attrs: {
                "id": "btn-popover-".concat(i),
                "variant": "outline-primary",
                "size": "sm"
              }
            }, [_vm._v(" Action ")]), _c('b-popover', {
              attrs: {
                "target": "btn-popover-".concat(i),
                "triggers": "focus",
                "placement": "bottom"
              }
            }, [_c('b-button', {
              attrs: {
                "variant": "outline",
                "size": "sm"
              },
              on: {
                "click": function click($event) {
                  return _vm.handleDelete(item);
                }
              }
            }, [_vm._v(" Reset Running Hours ")]), _c('b-button', {
              staticClass: "mt-2",
              attrs: {
                "variant": "outline",
                "size": "sm"
              },
              on: {
                "click": function click() {
                  return _vm.handleShowHistory(item.vehicle_id);
                }
              }
            }, [_vm._v(" History Reset Running Hours ")])], 1)], 1)])]) : _vm._e(), _c('td', {
              staticClass: "text-center column-2 bg-white",
              class: (item === null || item === void 0 ? void 0 : (_item$powers = item.powers) === null || _item$powers === void 0 ? void 0 : _item$powers.length) == j + 1 ? 'border-yellow' : ''
            }, [_vm._v(" " + _vm._s(_vm.formatNumber(subItem === null || subItem === void 0 ? void 0 : subItem.lastMonth)) + " ")]), _c('td', {
              staticClass: "column-3 bg-white border-none",
              class: (item === null || item === void 0 ? void 0 : (_item$powers2 = item.powers) === null || _item$powers2 === void 0 ? void 0 : _item$powers2.length) == j + 1 ? 'border-yellow' : ''
            }, [_c('div', {
              staticClass: "m-0 p-0"
            }, [_c('strong', [_vm._v(_vm._s((_subItem$power_type = subItem === null || subItem === void 0 ? void 0 : subItem.power_type) !== null && _subItem$power_type !== void 0 ? _subItem$power_type : '-'))])]), _c('small', {
              staticClass: "m-0 p-0"
            }, [_vm._v(" " + _vm._s((_subItem$power_series = subItem === null || subItem === void 0 ? void 0 : subItem.power_series) !== null && _subItem$power_series !== void 0 ? _subItem$power_series : '-') + " ")])]), _vm._l(subItem === null || subItem === void 0 ? void 0 : subItem.days, function (value, day) {
              var _item$powers3;
              return _c('td', {
                key: day,
                class: (item === null || item === void 0 ? void 0 : (_item$powers3 = item.powers) === null || _item$powers3 === void 0 ? void 0 : _item$powers3.length) == j + 1 ? 'border-yellow' : '',
                staticStyle: {
                  "min-width": "60px"
                }
              }, [_c('input', {
                staticClass: "input-update-rh",
                staticStyle: {
                  "max-width": "60px"
                },
                attrs: {
                  "type": "number"
                },
                domProps: {
                  "value": value
                },
                on: {
                  "focus": function focus($event) {
                    _vm.cellValue = value;
                  },
                  "blur": function blur(e) {
                    return _vm.handleBlurUpdate(e, subItem, day, item.vehicle_id);
                  }
                }
              })]);
            }), _c('td', {
              staticClass: "text-center text-primary",
              class: (item === null || item === void 0 ? void 0 : (_item$powers4 = item.powers) === null || _item$powers4 === void 0 ? void 0 : _item$powers4.length) == j + 1 ? 'border-yellow' : ''
            }, [_c('span', {
              staticClass: "cursor-pointer",
              on: {
                "click": function click($event) {
                  return _vm.handleOpenAdjustment(item, subItem);
                }
              }
            }, [_vm._v(" " + _vm._s(_vm.formatNumber(subItem === null || subItem === void 0 ? void 0 : subItem.totalAdjustment)) + " ")])]), _c('td', {
              staticClass: "text-center",
              class: (item === null || item === void 0 ? void 0 : (_item$powers5 = item.powers) === null || _item$powers5 === void 0 ? void 0 : _item$powers5.length) == j + 1 ? 'border-yellow' : ''
            }, [_vm._v(" " + _vm._s(_vm.formatNumber(subItem.thisMonth)) + " ")]), _c('td', {
              staticClass: "text-center",
              class: (item === null || item === void 0 ? void 0 : (_item$powers6 = item.powers) === null || _item$powers6 === void 0 ? void 0 : _item$powers6.length) == j + 1 ? 'border-yellow' : ''
            }, [_vm._v(" " + _vm._s(_vm.formatNumber(subItem === null || subItem === void 0 ? void 0 : (_subItem$sinceGOH = subItem.sinceGOH) === null || _subItem$sinceGOH === void 0 ? void 0 : _subItem$sinceGOH.running_hours_since_overhaul)) + " ")]), _c('td', {
              staticClass: "text-center",
              class: (item === null || item === void 0 ? void 0 : (_item$powers7 = item.powers) === null || _item$powers7 === void 0 ? void 0 : _item$powers7.length) == j + 1 ? 'border-yellow' : ''
            }, [_vm._v(" " + _vm._s(_vm.formatNumber(subItem === null || subItem === void 0 ? void 0 : subItem.totalRunningHour)) + " ")])], 2);
          });
        })], 2)])]), _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-between"
        }, [_c('p', {
          staticClass: "mb-0"
        }, [_vm._v(" Total Rows: "), _c('strong', {
          staticClass: "text-black"
        }, [_vm._v(_vm._s(_vm.rhData.params.total))])]), _c('div', {
          staticClass: "d-flex justify-content-end"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.rhData.params.total,
            "per-page": _vm.rhData.params.limit,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": function change(page) {
              _vm.rhData.params.page = page;
              _vm.fetchDataRh();
            }
          },
          model: {
            value: _vm.rhData.params.page,
            callback: function callback($$v) {
              _vm.$set(_vm.rhData.params, "page", $$v);
            },
            expression: "rhData.params.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "input": _vm.fetchDataRh
          },
          model: {
            value: _vm.rhData.params.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.rhData.params, "limit", $$v);
            },
            expression: "rhData.params.limit"
          }
        })], 1)])]) : _vm._e()] : [_c('div', {
          staticClass: "w-100 d-flex justify-content-center align-items-center my-5 py-5"
        }, [_c('b-spinner')], 1)], !((_vm$rhData$data2 = _vm.rhData.data) !== null && _vm$rhData$data2 !== void 0 && _vm$rhData$data2.length) && !_vm.loading ? [_c('b-col', {
          attrs: {
            "cols": "12"
          }
        }, [_vm._v("No Data Here!")])] : _vm._e()], 2)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }